"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapPayoutEligibilityQueryKapiToPayoutEligibilityCX = exports.mapLegacyToPayoutEligibilityCX = exports.mapLegacyToPaymentDetailsCX = exports.mapKapiToPaymentDetailsCX = void 0;
var __generated__1 = require("../../../../shared/api/kapi/v1/__generated__/");
var core_1 = require("../../../../shared/core");
var errors_1 = require("./errors");
var paymentScheduleIsActve = function (_a) {
    var status = _a.status;
    return status === __generated__1.PaymentScheduleStatus.Active;
};
var mandateHasBookedPayment = function (id, edges) {
    return edges.some(function (_a) {
        var _b = _a.node, paymentMandateId = _b.paymentMandateId, status = _b.status;
        return status === __generated__1.PaymentStatus.Booked && paymentMandateId === id;
    });
};
var mapKapiToPaymentDetailsCX = function (data) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return data.account.paymentSchedule &&
        paymentScheduleIsActve(data.account.paymentSchedule)
        ? {
            paymentSchedule: {
                scheduleDay: (_a = data.account.paymentSchedule) === null || _a === void 0 ? void 0 : _a.scheduleDay,
                amount: (_b = data.account.paymentSchedule) === null || _b === void 0 ? void 0 : _b.amount.value,
                currency: (_c = data.account.paymentSchedule) === null || _c === void 0 ? void 0 : _c.amount.currency,
                id: (_d = data.account.paymentSchedule) === null || _d === void 0 ? void 0 : _d.id,
                frequency: (_e = data.account.paymentSchedule) === null || _e === void 0 ? void 0 : _e.frequency,
                day: (_f = data.account.paymentSchedule) === null || _f === void 0 ? void 0 : _f.scheduleDay,
                method: (_g = data.account.paymentSchedule) === null || _g === void 0 ? void 0 : _g.paymentMandate.type,
                digits: (_h = data.account.paymentSchedule) === null || _h === void 0 ? void 0 : _h.paymentMandate.obfuscatedPaymentDetails,
            },
            hasBookedPayment: mandateHasBookedPayment(data.account.paymentSchedule.paymentMandate.id, data.account.paymentTransactions.edges),
            paymentRecommendation: data.account.paymentRecommendation
                ? {
                    roundedRecommendationAmount: data.account.paymentRecommendation.roundedRecommendationAmount
                        .value,
                    recommendationAmount: data.account.paymentRecommendation.recommendationAmount.value,
                    minimumRecommendationAmount: data.account.paymentRecommendation.minimumRecommendationAmount
                        .value,
                }
                : undefined,
        }
        : {};
};
exports.mapKapiToPaymentDetailsCX = mapKapiToPaymentDetailsCX;
var mapLegacyToPaymentDetailsCX = function (data) {
    var _a;
    return data.dayOfMonth && data.amount
        ? {
            paymentSchedule: {
                scheduleDay: data.dayOfMonth,
                amount: (_a = data.amount) === null || _a === void 0 ? void 0 : _a.amount,
            },
        }
        : {};
};
exports.mapLegacyToPaymentDetailsCX = mapLegacyToPaymentDetailsCX;
//All numbers from and to eligibility legacy apis are in pence
var mapLegacyToPayoutEligibilityCX = function (data) {
    var _a, _b;
    if ((data === null || data === void 0 ? void 0 : data.minimumRefund) !== undefined) {
        var eligibilityData = data;
        return {
            minimumAmount: Number((0, core_1.minorToMajor)(eligibilityData.minimumRefund)),
            maximumAmount: Number((0, core_1.minorToMajor)(eligibilityData.maximumRefund)),
            balance: Number((0, core_1.minorToMajor)(eligibilityData.balance)),
        };
    }
    else {
        return {
            minimumAmount: 0,
            maximumAmount: 0,
            balance: 0,
            reasonCode: (_b = (_a = data === null || data === void 0 ? void 0 : data.error) === null || _a === void 0 ? void 0 : _a.reasonCode) !== null && _b !== void 0 ? _b : '',
        };
    }
};
exports.mapLegacyToPayoutEligibilityCX = mapLegacyToPayoutEligibilityCX;
var mapPayoutEligibilityQueryKapiToPayoutEligibilityCX = function (data) {
    var _a, _b, _c;
    var payoutEligibilityData = (_a = data.customerAccountRelationship_nextV1) === null || _a === void 0 ? void 0 : _a.payoutEligibility;
    if (payoutEligibilityData) {
        var reasonCodes = payoutEligibilityData.reasonCodes;
        if (reasonCodes &&
            reasonCodes.length !== 0 &&
            reasonCodes.filter(function (x) { return x !== null; }).length !== 0) {
            return {
                minimumAmount: 0.0,
                maximumAmount: 0.0,
                balance: 0.0,
                reasonCode: (0, errors_1.isKapiReasonCode)(reasonCodes[0])
                    ? reasonCodes[0]
                    : 'GENERIC',
            };
        }
        return {
            minimumAmount: Number(payoutEligibilityData.minimumDirectCreditAmount.value),
            maximumAmount: Number(payoutEligibilityData.maximumDirectCreditAmount.value),
            balance: ((_b = data.customerAccountRelationship_nextV1) === null || _b === void 0 ? void 0 : _b.account.currentBalance)
                ? Number((_c = data.customerAccountRelationship_nextV1) === null || _c === void 0 ? void 0 : _c.account.currentBalance.amount.value)
                : 0.0,
            reasonCode: undefined,
        };
    }
    //no payout eligibility data but also no errors
    return {
        minimumAmount: 0.0,
        maximumAmount: 0.0,
        balance: 0.0,
        reasonCode: 'GENERIC',
    };
};
exports.mapPayoutEligibilityQueryKapiToPayoutEligibilityCX = mapPayoutEligibilityQueryKapiToPayoutEligibilityCX;
